import { render, staticRenderFns } from "./SponsorModal.vue?vue&type=template&id=842de9a8&"
import script from "./SponsorModal.vue?vue&type=script&lang=js&"
export * from "./SponsorModal.vue?vue&type=script&lang=js&"
import style0 from "./SponsorModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "SponsorModal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/modals/SponsorModal.vue
// module id = 2338
// module chunks = 1